import styled, {css} from "styled-components";
import {PC_HORIZONTAL_SPACE_BETWEEN_ITEMS} from "../../../../../../../../basic-components/space-between-items-consts";

export const GamePlayPcHeaderBarGameModeToggleContainerDefaultBox = styled.div<{isInRealMode: boolean}>`
    display: flex;
    flex-direction: row;
    cursor: pointer;
    
    width: 40px;
    height: 22px;
    border-radius: 20px;
    
    margin-left: ${PC_HORIZONTAL_SPACE_BETWEEN_ITEMS()};
    margin-right: ${PC_HORIZONTAL_SPACE_BETWEEN_ITEMS()};
  
    ${
    props => props.isInRealMode
        ? css`
                  background-color: ${props => props.theme.colors.brandPrimary};
                  justify-content: flex-start;
                `
        : css`
                  background-color: ${props => props.theme.colors.backgroundDark};
                  justify-content: flex-end;
                `
}
`